<div class="presentation-value" [ngClass]="{'hide': edited}">
  <div>{{ oldValue }}</div>
  <div><i class="far fa-pencil-alt" (click)="switchMode()" aria-hidden="true"></i>&nbsp;</div>
</div>
<div class="input-value" [ngClass]="{'hide': !edited}">
  <div class="input-component"
    [ngClass]="{'pristine': (pristine$ | async), 'valid': (validStatus$ | async), 'invalid': (invalidStatus$ | async), 'disabled': (disabled$ | async)}">
    <span class="firstError">{{ firstError$() | async }}{{ noMoreError$() | async }}</span>
    <div class="input-wrapper">
      <input [disabled]="notEnabled" type="text" class="input-field" [attr.required]="required" [(ngModel)]="value"
        [id]="fieldId" [name]="name" [attr.value]="value" />
        <label [attr.for]="fieldId">{{label}}</label>
        @if ((dirtyStatus$ | async)) {
          <span class="input-validation fa-stack fa-1x">
            <i class="fas fa-stack-2x fa-circle" aria-hidden="true"></i>
            <i class="fal fa-stack-1x"
              [ngClass]="{'fa-check': (validStatus$ | async), 'fa-times': (invalidStatus$ | async)}"
            aria-hidden="true"></i>
          </span>
        }
      </div>
    </div>
    <div>
      <i class="far fa-times fa-lg" (click)="cancel()" aria-hidden="true"></i></div>
      <div>
        <i class="far fa-save fa-lg" (click)="save()" aria-hidden="true"></i>&nbsp;
      </div>
    </div>
